import { get_token } from '@/router/index.js';


export default {
  name: 'CreateCase',
  data: () => ({
      workspace_map: {
        case_intake: "Case Intake",
        credit_help: "Credit Help",
      },
  }),
  computed: {
    is_demo_domain() {
    if (window.location.hostname === "demo.live.aic-one.com") return true;

    return window.location.hostname.includes("demo.live.aic-one.com");
    },
  },

  methods: {
    async launch_workspace(tab) {

      const allowed = Object.keys(this.workspace_map);
      if (!allowed.includes(tab)) {
        console.error("Invalid workspace key:", tab);
        return;
      }

      const workspace_type = Reflect.get(this.workspace_map, tab);

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/create_workspace/`;
      const is_Demo = this.is_demo_domain;
      const token = is_Demo ? null : get_token();

      if (!is_Demo && !token) {
        return;
      }

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { "Authorization": `Token ${token}` } : {}),
            'X-Page-URL': window.location.href,
          },
          body: JSON.stringify({ workspace: workspace_type }),
        });

        const data = await response.json();

        if (response.ok) {
          window.location = data.redirect_url;
        } else {
          this.$notyf.error(data?.message || "Service currently unavailable.");
        }
      } catch (error) {
        this.$notyf.error(`Error: ${String(error)}`);
      }
    },
  }
}